/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cognito_Invitation_Security_NoteInputs */

const en_cognito_invitation_security_note = /** @type {(inputs: Cognito_Invitation_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For security reasons, you must set a new password on your first sign-in.`)
};

const pt_br2_cognito_invitation_security_note = /** @type {(inputs: Cognito_Invitation_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por motivos de segurança, você precisará definir uma nova senha no primeiro acesso.`)
};

/**
* | output |
* | --- |
* | "For security reasons, you must set a new password on your first sign-in." |
*
* @param {Cognito_Invitation_Security_NoteInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cognito_invitation_security_note = /** @type {((inputs?: Cognito_Invitation_Security_NoteInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cognito_Invitation_Security_NoteInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cognito_invitation_security_note(inputs)
	return pt_br2_cognito_invitation_security_note(inputs)
});